
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.375 7a4.375 4.375 0 10-8.75 0 4.375 4.375 0 008.75 0zm1.25 0a5.625 5.625 0 11-11.25 0 5.625 5.625 0 0111.25 0z","fill":"#4A4A4A"}}),_c('path',{attrs:{"d":"M10.093 10.093a.626.626 0 01.786-.08l.099.08 3.464 3.465.08.098a.626.626 0 01-.866.866l-.098-.08-3.465-3.464-.08-.099a.626.626 0 01.08-.786z","fill":"#4A4A4A"}})])
          )
        }
      }
    